<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 分区计量水表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="仪表编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入仪表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表口径">
              <a-input v-model="query.diameter" placeholder="请输入水表口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>

              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <!--              <a-button type="primary" style="margin-left: 8px" @click="historyData()">历史数据</a-button>-->
              <a-button style="margin-left: 8px" @click="exportHandle()" type="primary" v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ execlForm: true })"
                v-action:upload>下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest">
                <a-button style="margin-left: 8px" type="primary" :loading="importLoading" v-action:import>导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]" style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
            :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search treeNodeFilterProp="title"></a-tree-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码" hasFeedback>
          <a-input placeholder="分类编码" v-decorator="['classNo', { rules: [{ required: true, message: '请输入分类编码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仪表编号" hasFeedback>
          <a-input :disabled="!this.$store.state.user.info.systemAdmin && this.isUpdate" placeholder="仪表编号"
            v-decorator="['appearanceNo', { rules: [{ required: true, message: '请输入仪表编号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仪表名称" hasFeedback>
          <a-input placeholder="仪表名称"
            v-decorator="['appearanceName', { rules: [{ required: true, message: '仪表名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径" hasFeedback>
          <a-input placeholder="口径" v-decorator="['diameter', { rules: [{ required: true, message: '请输入正确口径' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌" hasFeedback>
          <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: true, message: '请输入品牌' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型" hasFeedback>
          <a-input placeholder="类型" v-decorator="['typeStr', { rules: [{ required: true, message: '请输入类型' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址" hasFeedback>
          <a-input placeholder="地址" v-decorator="['address', { rules: [{ required: true, message: '请输入地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="流出" hasFeedback>
          <a-input placeholder="流出" v-decorator="['outflow', { rules: [{ required: true, message: '请输入流出' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="流入" hasFeedback>
          <a-input placeholder="流入" v-decorator="['flowInto', { rules: [{ required: true, message: '请输入流入' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经度" hasFeedback>
          <a-input placeholder="经度" v-decorator="[
            'longitude',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确经度' }] },
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="纬度" hasFeedback>
          <a-input placeholder="纬度" v-decorator="[
            'latitude',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确纬度' }] },
          ]" />
          <!-- ^(-?\d+)(\.\d+)?$  -->
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="H高程" hasFeedback>
          <a-input placeholder="H高程" v-decorator="[
            'groundElevation',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确H高程' }] },
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="埋设时间">
          <a-date-picker placeholder="埋设时间" :allowClear="false"
            v-decorator="['deliveryTime', { rules: [{ required: true, message: '请选择埋设时间' }] }]" format="YYYY"
            mode="year" :open="open" @openChange="openChange" @panelChange="panelChange" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" hasFeedback>
          <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '备注' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
const STATUS = {
  1: '正常',
  2: '禁用'
}
const columns = [
  {
    title: '分类编码',
    dataIndex: 'classNo'
  },
  {
    title: '仪表编号',
    dataIndex: 'appearanceNo'
  },
  {
    title: '仪表名称',
    dataIndex: 'appearanceName'
  },
  {
    title: '口径',
    dataIndex: 'diameter'
  },
  {
    title: '品牌',
    dataIndex: 'brand'
  },
  {
    title: '类型',
    dataIndex: 'typeStr'
  },
  {
    title: '地址',
    dataIndex: 'address'
  },
  {
    title: '流出',
    dataIndex: 'outflow'
  },
  {
    title: '流入',
    dataIndex: 'flowInto'
  },
  {
    title: '经度',
    dataIndex: 'longitude'
  },
  {
    title: '纬度',
    dataIndex: 'latitude'
  },
  {
    title: 'H高程',
    dataIndex: 'groundElevation'
  },
  {
    title: '埋设时间',
    dataIndex: 'deliveryTime'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    width: '100px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    // HistoryModal
  },
  mixins: [mixinViewModule],
  name: 'RemoteWaterMeterList',
  data () {
    return {
      open: false,
      importLoading: false,
      downloadTemplateUrl: 'pipe-network/remote-meters/template/download', // 水表模板
      downloadTemplateName: '分区计量仪表导入模板.xlsx',
      fileList: [],
      exportDataUrl: 'pipe-network/remote-meters/export',
      exportFileName: '分区计量仪表.xlsx',
      queryUrl: 'pipe-network/remote-meters/page',
      addOrUpdateUrl: 'pipe-network/remote-meters',
      queryOneUrl: 'pipe-network/remote-meters',
      deleteUrl: 'pipe-network/remote-meters',
      downloadUrl: 'pipe-network/remote-meters/export',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      query: {
        classNo: '',
        appearanceNo: '',
        tenantId: this.$store.state.user.info.tenantId,
        diameter: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      zoneTreeData: [], // 片区选项
      treeDefaultExpandedKeys: [] // 默认展开的树节点
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.getAllTenant()
    this.getZoneData()
  },
  methods: {
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
      })
    },
    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    panelChange (value) {
      this.addOrUpdateForm.setFieldsValue({ deliveryTime: value })
      this.open = false
    },
    openChange (status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    historyData () {
      this.$refs.historyModal.show()
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/remote-meters/import',
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    changeFile (info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values
          }
          console.log(params)
          typeof params.deliveryTime === 'string' ? '' : (params.deliveryTime = params.deliveryTime.format('YYYY'))
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
